import { api } from './client'

/**
 * A conversa do @DBA sobre o banco aberto no editor (spec 2026-10-31-dba-conversa-do-banco §3.1).
 *
 * Cada banco tem a sua: abrir de novo o mesmo banco retoma a conversa dele, e `nova` abre outra
 * (o "Nova conversa" do painel). O servidor confere o portão do @DBA antes de abrir.
 */
export interface BancoAberto {
  db_identifier: string
  db_name?: string | null
  credential_id?: number | null
}

export interface ConversaDoBanco {
  conversation_id: number
  criada: boolean
  db_identifier: string
  db_name: string | null
}
export interface ConversaRecente {
  conversation_id: number
  tenant_id: number
  tenant_nome: string | null
  db_identifier: string
  db_name: string | null
  titulo: string | null
  criada_em: string
  ultima_atividade: string
}

export const dbaConversasApi = {
  abrir: (tenantId: number, banco: BancoAberto, nova = false) =>
    api.post<ConversaDoBanco>(`/v1/tenants/${tenantId}/dba/conversas`, { ...banco, nova })
      .then((r) => r.data),
  /** As da pessoa com atividade nos últimos 7 dias; com o banco, só as dele (as "anteriores"). */
  recentes: (filtro?: { tenant_id: number; db_identifier: string; db_name?: string | null }) =>
    api.get<{ items: ConversaRecente[]; dias_ate_arquivar: number }>('/v1/dba/conversas', {
      params: filtro ? { ...filtro, db_name: filtro.db_name ?? undefined } : undefined,
    }).then((r) => r.data),
}
